import React, { useState, useEffect, useCallback } from 'react';
import { tallerService } from '../services/api';

function FotosTrabajo({ trabajoId }) {
  const [fotos, setFotos] = useState([]);
  const [subiendo, setSubiendo] = useState(false);

  const cargar = React.useCallback(() => {
    tallerService.fotos(trabajoId).then(r => setFotos(r.data || [])).catch(() => {});
  }, [trabajoId]);
  useEffect(() => { cargar(); }, [cargar]);

  const subir = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setSubiendo(true);
    try {
      await tallerService.subirFoto(trabajoId, file);
      cargar();
    } catch (err) {
      alert(err.response?.data?.error || "Error al subir la foto");
    } finally {
      setSubiendo(false);
      e.target.value = "";
    }
  };

  const borrar = async (fotoId) => {
    if (!window.confirm("¿Borrar esta foto?")) return;
    try { await tallerService.borrarFoto(trabajoId, fotoId); cargar(); }
    catch { alert("Error al borrar"); }
  };

  return (
    <div style={{ marginTop: 10 }}>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
        {fotos.map(f => (
          <div key={f.id} style={{ position: "relative" }}>
            <img src={"/uploads/trabajos/" + f.filename} alt="trabajo" style={{ width: 70, height: 70, objectFit: "cover", borderRadius: 8, border: "1px solid #e0d0c0" }} />
            <button onClick={() => borrar(f.id)} style={{ position: "absolute", top: -6, right: -6, background: "#c0392b", color: "#fff", border: "none", borderRadius: "50%", width: 20, height: 20, fontSize: 12, cursor: "pointer", lineHeight: 1 }}>×</button>
          </div>
        ))}
      </div>
      {fotos.length < 3 && (
        <label style={{ display: "inline-block", background: "#a0522d", color: "#fff", padding: "8px 14px", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
          {subiendo ? "Subiendo…" : "📷 Subir foto"}
          <input type="file" accept="image/*" onChange={subir} style={{ display: "none" }} disabled={subiendo} />
        </label>
      )}
    </div>
  );
}

// Lunes y sábado de la semana que contiene la fecha dada
function semanaLunSab(fecha) {
  const d = new Date(fecha);
  const dia = d.getDay();
  const difLunes = dia === 0 ? 6 : dia - 1;
  const lunes = new Date(d);
  lunes.setDate(d.getDate() - difLunes);
  lunes.setHours(0, 0, 0, 0);
  const sabado = new Date(lunes);
  sabado.setDate(lunes.getDate() + 5);
  sabado.setHours(23, 59, 59, 999);
  return { lunes, sabado };
}

export default function MiTrabajo() {
  const [trabajos, setTrabajos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [semana, setSemana] = useState(() => semanaLunSab(new Date()));
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const res = await tallerService.miTrabajo();
      setTrabajos(res.data || []);
      setError('');
    } catch (err) {
      setError('Error al cargar tu trabajo');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const terminar = async (id) => {
    try {
      const r = await tallerService.fotos(id);
      if (!r.data || r.data.length === 0) {
        alert('Debés subir al menos una foto del trabajo antes de marcarlo como terminado.');
        return;
      }
    } catch {
      alert('No se pudo verificar las fotos. Intentá de nuevo.');
      return;
    }
    if (!window.confirm('¿Marcar este trabajo como terminado?')) return;
    try {
      await tallerService.terminar(id);
      cargar();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al marcar terminado');
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/';
  };

  const irSemana = (dir) => {
    const nuevoLunes = new Date(semana.lunes);
    nuevoLunes.setDate(nuevoLunes.getDate() + dir * 7);
    setSemana(semanaLunSab(nuevoLunes));
  };

  const esSemanaActual = () => {
    const actual = semanaLunSab(new Date());
    return actual.lunes.getTime() === semana.lunes.getTime();
  };

  const pendientes = trabajos.filter(t => t.estado !== 'Terminado');
  // Historial filtrado a la semana seleccionada (por fecha_terminado, lun-sáb)
  const historialSemana = trabajos.filter(t => {
    if (t.estado !== 'Terminado' || !t.fecha_terminado) return false;
    const ft = new Date(t.fecha_terminado);
    return ft >= semana.lunes && ft <= semana.sabado;
  });
  const totalSemana = historialSemana.reduce((sum, t) => sum + Number(t.monto || 0), 0);

  const s = {
    page: { minHeight: '100vh', background: '#f5f0e8', paddingBottom: 40 },
    header: { background: '#5c3d2e', color: '#fff', padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    container: { maxWidth: 600, margin: '0 auto', padding: 16 },
    card: { background: '#fff', borderRadius: 12, padding: 16, marginBottom: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' },
    etapaBadge: (etapa) => ({ display: 'inline-block', padding: '3px 10px', borderRadius: 10, fontSize: 12, fontWeight: 600, background: etapa === 'costura' ? '#e0e7ff' : '#fce7d4', color: etapa === 'costura' ? '#3730a3' : '#9a3412' }),
    btnTerminar: { background: '#1e7e34', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: 8, cursor: 'pointer', fontSize: 15, fontWeight: 600, width: '100%', marginTop: 10 },
    seccion: { fontSize: 16, fontWeight: 700, color: '#5c3d2e', margin: '20px 0 10px' },
    navBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#fff', borderRadius: 12, padding: 12, marginBottom: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' },
    navBtn: { background: '#5c3d2e', color: '#fff', border: 'none', width: 44, height: 44, borderRadius: 8, cursor: 'pointer', fontSize: 20, fontWeight: 700 },
    totalBox: { background: '#1e7e34', color: '#fff', borderRadius: 12, padding: 14, marginBottom: 12, textAlign: 'center' },
  };

  const fmtFecha = (f) => f ? new Date(f).toLocaleDateString('es-CR') : '';
  const fmt = (n) => '₡' + Number(n || 0).toLocaleString('es-CR');
  const fmtDia = (d) => d.toLocaleDateString('es-CR', { day: 'numeric', month: 'short' });

  return (
    <div style={s.page}>
      <div style={s.header}>
        <strong style={{ fontSize: 18 }}>🧵 Mi Trabajo</strong>
        <div>
          <span style={{ fontSize: 13, marginRight: 12 }}>👤 {user.name?.split(' ')[0]}</span>
          <button style={{ background: '#c0392b', color: '#fff', border: 'none', padding: '5px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 13 }} onClick={logout}>Salir</button>
        </div>
      </div>

      <div style={s.container}>
        {loading && <p>Cargando…</p>}
        {error && <p style={{ color: '#c0392b' }}>{error}</p>}

        {!loading && (
          <>
            {/* PENDIENTES (sin agrupar por semana) */}
            <div style={s.seccion}>Trabajos pendientes ({pendientes.length})</div>
            {pendientes.length === 0 && <div style={s.card}>No tenés trabajos pendientes.</div>}
            {pendientes.map(t => (
              <div key={t.id} style={s.card}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                  <strong style={{ color: '#5c3d2e', fontSize: 16 }}>{t.numero}</strong>
                  <span style={s.etapaBadge(t.etapa)}>{t.etapa === 'costura' ? 'Costura' : 'Tapicería'}</span>
                </div>
                <div style={{ fontSize: 14, color: '#333' }}>{t.articulos || '—'}</div>
                <div style={{ fontSize: 13, color: '#8a7a6a', marginTop: 4 }}>Cliente: {t.cliente}</div>
                {t.tela_metraje && <div style={{ fontSize: 13, color: '#8a7a6a' }}>Metraje: {t.tela_metraje} m</div>}
                {t.delivery_date && <div style={{ fontSize: 13, color: '#8a7a6a' }}>Entrega: {fmtFecha(t.delivery_date)}</div>}
                {t.nota && <div style={{ fontSize: 13, color: '#8a7a6a', fontStyle: 'italic' }}>Nota: {t.nota}</div>}
                <button style={s.btnTerminar} onClick={() => terminar(t.id)}>✓ Marcar Terminado</button>
                <FotosTrabajo trabajoId={t.id} />
              </div>
            ))}

            {/* HISTORIAL por semana (lun-sáb) */}
            <div style={s.seccion}>Mi semana</div>
            <div style={s.navBar}>
              <button style={s.navBtn} onClick={() => irSemana(-1)}>◀</button>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#5c3d2e' }}>{fmtDia(semana.lunes)} – {fmtDia(semana.sabado)}</div>
                {esSemanaActual() && <div style={{ fontSize: 12, color: '#1e7e34', fontWeight: 600 }}>Semana actual</div>}
              </div>
              <button style={{ ...s.navBtn, opacity: esSemanaActual() ? 0.4 : 1 }} onClick={() => irSemana(1)} disabled={esSemanaActual()}>▶</button>
            </div>

            {historialSemana.length > 0 && (
              <div style={s.totalBox}>
                <div style={{ fontSize: 13, opacity: 0.9 }}>Total de la semana ({historialSemana.length} trabajos)</div>
                <div style={{ fontSize: 26, fontWeight: 800 }}>{fmt(totalSemana)}</div>
              </div>
            )}
            {historialSemana.map(t => (
              <div key={t.id} style={s.card}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                  <strong style={{ color: '#5c3d2e', fontSize: 15 }}>{t.numero}</strong>
                  <span style={s.etapaBadge(t.etapa)}>{t.etapa === 'costura' ? 'Costura' : 'Tapicería'}</span>
                </div>
                <div style={{ fontSize: 13, color: '#333' }}>{t.articulos || '—'}</div>
                {t.rubro && <div style={{ fontSize: 14, color: '#5c3d2e', fontWeight: 700, marginTop: 4 }}>{t.rubro} · {fmt(t.monto)}</div>}
                <div style={{ fontSize: 12, color: '#1e7e34', marginTop: 4 }}>✓ Terminado el {fmtFecha(t.fecha_terminado)}</div>
                {t.pagado
                  ? <div style={{ fontSize: 12, color: '#1e7e34', fontWeight: 700, marginTop: 2 }}>💰 Cancelado</div>
                  : <div style={{ fontSize: 12, color: '#856404', fontWeight: 600, marginTop: 2 }}>⏳ Pendiente de pago</div>}
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
